<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_colonizing_intro')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/map/galaxy')
})

const goToPlanets = () => {
  router.push('/map/galaxy')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/colonizing.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.colonizing.advisor.greetings') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.colonizing.advisor.guideYou') }}
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        {{ t('common.actions.gotoMap') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.colonizing.advisor.niceToMeet') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>